// extracted by mini-css-extract-plugin
module.exports = {"newItems":"Files_newItems__4joZy","itemsList":"Files_itemsList__axgfs"};